import { PageHeader, Panel } from '../components/ui';
import { SERVICES } from '@inbrief/shared';

/**
 * Human consultancy, priced separately and explicitly optional.
 *
 * The strategies and recommendations described here are things people do.
 * Nothing in the software generates them, and this page must never imply that
 * it does — the product's boundary against clinical decision support depends
 * on that line staying clean.
 */
export function Services() {
  return (
    <>
      <PageHeader
        title="InBrief Services"
        description="Optional help from people, when a contract needs more than reading. None of this is required to use the software."
      />

      <div className="note-box">
        These are human services delivered by consultants. The software does not generate
        performance-improvement strategies or operational recommendations, and buying a service does
        not change what the software does.
      </div>

      <Panel title="What we offer" icon="◈">
        <div className="table-wrap">
          <table className="dt">
            <caption className="visually-hidden">Available services</caption>
            <thead>
              <tr><th scope="col">Service</th><th scope="col">Basis</th></tr>
            </thead>
            <tbody>
              {SERVICES.map((s) => (
                <tr key={s.id}>
                  <th scope="row">{s.name}</th>
                  <td className="svc-price">{s.rate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="vat-note">All rates exclude VAT and are quoted per engagement.</p>
      </Panel>

      <Panel title="What the software does on its own" icon="✓">
        <ul>
          <li>Reads a contract and extracts obligations, KPIs, deadlines, funding and eligibility rules.</li>
          <li>Shows every extracted item next to the passage it came from.</li>
          <li>Answers questions about a contract, quoting the clause, and refusing when the contract is silent.</li>
          <li>Drafts patient communications from information your practice has approved.</li>
          <li>Translates approved communications, for a person to check.</li>
          <li>Matches funding opportunities against your profile.</li>
        </ul>
      </Panel>

      <Panel title="What it deliberately does not do" icon="✕">
        <ul>
          <li>Send anything to a patient.</li>
          <li>Connect to a clinical system, or see any patient record.</li>
          <li>Give clinical advice, diagnosis, triage, or medication or treatment recommendations.</li>
          <li>Tell you which of your patients are outstanding on anything.</li>
          <li>Generate a strategy for hitting a target, or recommend operational changes.</li>
          <li>Assert that you are eligible for funding, or predict whether an application will succeed.</li>
        </ul>
        <p className="field-hint">
          These are product boundaries, not gaps waiting to be filled. Several of them are what keep
          InBrief outside the medical device regime.
        </p>
      </Panel>
    </>
  );
}
